import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { ArrowLeft } from 'lucide-react';
import { Logo } from '../components/Logo';
import { renderInlineMarkdown } from '../lib/markdown';
import Footer from '../components/Footer';

export default function PrivacyPage() {
    const [content, setContent] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        api.get('/privacy').then(r => setContent(r.data.content)).catch(console.error);
    }, []);

    return (
        <div className="min-h-screen bg-white">
            <nav className="border-b border-zinc-200 px-6 py-4">
                <div className="max-w-3xl mx-auto flex items-center gap-4">
                    <button onClick={() => navigate(-1)} className="text-zinc-400 hover:text-zinc-900"><ArrowLeft className="w-5 h-5" /></button>
                    <Logo size="md" data-testid="privacy-logo" />
                </div>
            </nav>
            <div className="max-w-3xl mx-auto px-6 py-12">
                <div className="prose prose-zinc max-w-none" data-testid="privacy-content">
                    {content.split('\n').map((line, i) => {
                        if (line.startsWith('# ')) return <h1 key={i} className="font-heading text-3xl font-black mb-4">{line.slice(2)}</h1>;
                        if (line.startsWith('## ')) return <h2 key={i} className="font-heading text-xl font-bold mt-8 mb-3">{line.slice(3)}</h2>;
                        // Whole-line bold (e.g. a standalone "**Effective Date:**" with nothing after it).
                        if (line.startsWith('**') && line.endsWith('**') && !line.slice(2, -2).includes('**')) {
                            return <p key={i} className="text-sm font-bold text-zinc-600 mb-4">{line.slice(2, -2)}</p>;
                        }
                        if (line.startsWith('- ')) return <li key={i} className="text-sm text-zinc-600 ml-4 mb-1">{renderInlineMarkdown(line.slice(2))}</li>;
                        if (line.startsWith('---')) return <hr key={i} className="my-6 border-zinc-200" />;
                        if (line.trim() === '') return <br key={i} />;
                        return <p key={i} className="text-sm text-zinc-600 mb-2 leading-relaxed">{renderInlineMarkdown(line)}</p>;
                    })}
                </div>
            </div>
            <Footer />
        </div>
    );
}
